function requiredParam(argName: string) {
	throw new Error(`${argName} as Parameter is required`);
}

export default requiredParam;
